import classnames from "classnames";
import Link from "next/link";
import { useSelector } from "react-redux";

import { getDomainCountryCode } from "redux/selectors/config";
import { getCurrentDispensary } from "redux/selectors/dispensary";
import { dispensaryHref } from "utils/dispensaryUrls";
import { trackMenuEvent } from "utils/trackEvent";

import Button from "components/botanic/Button";

const ShopAllButton: React.FC<{ className?: string }> = ({ className }) => {
  const { slug, retailType } = useSelector(getCurrentDispensary);
  const countryCode = useSelector(getDomainCountryCode);

  const href = dispensaryHref({
    additionalPath: "/deals",
    countryCode,
    retailType,
    slug,
  });

  const trackButtonClick = () =>
    trackMenuEvent("Click", "Shop All Products Button");

  return (
    <div
      data-testid="shop-all-button"
      className={classnames("row justify-center", className)}
    >
      <div className="col lg:col-6 flex flex-col items-center text-center">
        <h3 className="heading--m mb-xs">Want to see more?</h3>
        <span className="text-sm mb-xl">
          This button will take you to the full dispensary menu.
        </span>

        <Link href={href}>
          <Button
            data-testid="shop-all-link"
            className="button--primary"
            onClick={trackButtonClick}
            onKeyPress={trackButtonClick}
          >
            shop all
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ShopAllButton;
